import { render, staticRenderFns } from "./Info-stat-card.vue?vue&type=template&id=13de650f&scoped=true&"
import script from "./Info-stat-card.vue?vue&type=script&lang=js&"
export * from "./Info-stat-card.vue?vue&type=script&lang=js&"
import style0 from "./Info-stat-card.vue?vue&type=style&index=0&id=13de650f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13de650f",
  null
  
)

export default component.exports